import { TableSearch } from "ui/components/Table/TableSearch";
import { memo } from "react";

import { CONTACT_REPRESENTATIVE_SEARCH_COLUMNS } from "./consts";
import { ContactRepresentativeSearchResultsProps } from "./types";
import { useTranslate } from "helpers";

const ContactRepresentativeSearchResults: React.FC<ContactRepresentativeSearchResultsProps> = (props) => {
  const {
    data,
    isLoading,
    onRowClick,
    onPersonClick,
    onDeleteClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={CONTACT_REPRESENTATIVE_SEARCH_COLUMNS(t, onPersonClick, onDeleteClick)}
      data={data}
      selectableRows={false}
      disablePagination={true}
      isLoading={isLoading}
      onRowClick={onRowClick}
    />
  );
};

export default memo(ContactRepresentativeSearchResults);
